import { graphql } from "@opensea/graphql"

export const useScheduler_signatureRequestFragment = graphql(`
  fragment useScheduler_signatureRequest on SignatureRequest {
    __typename
    message
    ... on SignTypedDataRequest {
      chain {
        networkId
      }
    }
  }
`)

export const useScheduler_transactionSubmissionDataFragment = graphql(`
  fragment useScheduler_transactionSubmissionData on TransactionSubmissionData {
    to
    data
    value
    chain {
      networkId
    }
  }
`)

export const useScheduler_svmTransactionSubmissionDataFragment = graphql(`
  fragment useScheduler_svmTransactionSubmissionData on SvmTransactionSubmissionData {
    instructions {
      programId
      data
      keys {
        pubkey
        isSigner
        isWritable
      }
    }
    addressLookupTableAddresses
  }
`)

export const useScheduler_readShouldBufferGasFragment = graphql(`
  fragment useScheduler_readShouldBufferGas on BlockchainAction {
    __typename
    ... on TransactionAction {
      transactionSubmissionData {
        chain {
          identifier
        }
      }
    }
    ... on RelayerFulfillableAction {
      relayerFulfillment {
        sameChain
      }
    }
  }
`)

export const useScheduler_actionFragment = graphql(
  `
    fragment useScheduler_action on BlockchainAction {
      __typename
      ... on BlurAuthAction {
        chain {
          identifier
        }
        expiresOn
        hmac
        signatureRequest {
          message
          ...useScheduler_signatureRequest
        }
      }
      ... on RefreshAction {
        message
      }
      ... on SignatureRequestAction {
        signatureRequest {
          ...useScheduler_signatureRequest
        }
      }
      ... on TransactionAction {
        transactionSubmissionData {
          chain {
            networkId
            identifier
          }
          ...useScheduler_transactionSubmissionData
        }
      }
      ... on SvmTransactionAction {
        svmTransactionSubmissionData {
          ...useScheduler_svmTransactionSubmissionData
        }
      }
      ... on GaslessCancelOrdersAction {
        signatureRequest {
          ...useScheduler_signatureRequest
        }
      }
      ... on Permit2SignatureAction {
        __typename
        domain {
          name
          chainId
          verifyingContract
        }
        types {
          permitSingle {
            name
            type
          }
          permitDetails {
            name
            type
          }
        }
        transactionBuilder {
          commands
          deadline
          encodedInputs {
            permitInputTypes
            permitMessageForSigning {
              details {
                token
                amount
                expiration
                nonce
              }
              spender
              sigDeadline
            }
            payPortionInput
            swapInputs
          }
        }
        primaryType
        trxSignatureSuffix
      }
      ... on RelayerFulfillableAction {
        relayerFulfillment {
          requestId
          sameChain
          crossChain
        }
      }
      ...useScheduler_readShouldBufferGas
    }
  `,
  [
    useScheduler_signatureRequestFragment,
    useScheduler_transactionSubmissionDataFragment,
    useScheduler_svmTransactionSubmissionDataFragment,
    useScheduler_readShouldBufferGasFragment,
  ],
)
